import { Image } from '@/atoms/Image'
import { useTranslate } from '@/utils/translate/translate-client'
import { NameInCreditsCountdown } from '@/views/PayItForward/TheatricalPayItForwardView/components/NameInCreditsCountdown'
import { DavidButton } from './DavidButton'

export function NameInCreditsSection() {
  const { t } = useTranslate('pif')

  return (
    <section className="relative w-full bg-gradient-to-b from-[rgba(21,21,21,0.75)] to-[rgba(21,21,21,0)] px-[16px] pb-[72px] pt-[64px] md:px-[64px] md:pb-[96px] md:pt-[120px]">
      <div className="relative mx-auto flex w-full max-w-[1440px] shrink-0 flex-col items-start gap-[40px] self-stretch md:flex-row md:gap-0">
        {/* Image */}
        <div className="flex flex-[1_0_0] items-center justify-center self-stretch">
          <Image
            alt=""
            className="object-cover"
            src="/v1761147211/theatrical/david/saul-jonathan-name-credits.png"
            width={600}
            height={600}
            sizes="(max-width: 768px) 100vw, 600px"
          />
        </div>

        {/* Content */}
        <div className="flex w-full flex-col items-start justify-center gap-[32px] p-0 md:flex-[1_0_0] md:gap-[40px] md:self-stretch md:py-[64px] md:pl-[64px] md:pr-0">
          {/* Limited Time Badge and Copy */}
          <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[24px]">
            {/* Countdown Badge */}
            <NameInCreditsCountdown />

            {/* Main Copy */}
            <div className="relative flex w-full shrink-0 flex-col content-stretch items-start gap-[12px] not-italic text-white">
              <p className="font-angel-royal relative w-full shrink-0 text-[40px] lowercase not-italic leading-[40px] text-white md:text-[64px] md:leading-[64px]">
                {t('nameInCreditsHeading', 'Etch Your Name in the Movie Credits of DAVID')}
              </p>
              <p className="font-whitney-medium md:font-whitney-medium relative w-full shrink-0 text-[16px] not-italic leading-[24px] text-[#c9edf2] md:text-[18px] md:leading-[28px]">
                {t(
                  'davidEtchYourNameDescription',
                  "Pay it Forward for 35 kids ($500) to see DAVID and we'll thank you by including your name in the movie credits - across the theatrical, streaming, and DVD releases.",
                )}
              </p>
            </div>
          </div>

          {/* Cutoff Date */}
          <div className="relative flex w-full shrink-0 flex-col content-stretch items-start whitespace-pre text-nowrap text-[16px] not-italic leading-[28px] md:flex-row md:gap-[6px] md:text-[18px] md:leading-[30px]">
            <p className="font-whitney-bold relative shrink-0 text-[#c9edf2]">
              {t('theatricalCutoffDateLabel', 'Theatrical Cutoff Date:')}
            </p>
            <p className="font-whitney-medium relative shrink-0 text-[#c9edf2]">
              {t('theatricalCutoffDateValue', 'November 10, 2025')}
            </p>
          </div>

          {/* Button */}
          <DavidButton
            variant="cyan"
            href="https://shop.angel.com/products/david-preorder-theatrical-movie-ticket"
            className="w-full min-w-0 md:w-auto md:min-w-[200px]"
          >
            {t('payItForward', 'Pay it Forward')}
          </DavidButton>
        </div>
      </div>
    </section>
  )
}
